export default "<div [class]=\"'logo-'+ color\" style=\"height: 60px\"></div>\n";